import { DashboardChartSlice } from '../../services/dashboardApi';

type HorizontalBarChartProps = {
  title: string;
  items: DashboardChartSlice[];
  valueFormatter?: (value: number) => string;
};

function defaultFormatter(value: number): string {
  return String(value);
}

export function HorizontalBarChart({
  title,
  items,
  valueFormatter = defaultFormatter,
}: HorizontalBarChartProps) {
  const max = Math.max(...items.map((item) => item.value), 1);

  if (items.length === 0) {
    return (
      <div className="rounded-xl border border-secondary-200 bg-white p-5">
        <h3 className="font-semibold text-secondary-900">{title}</h3>
        <p className="mt-4 text-sm text-secondary-500">Sem dados para exibir.</p>
      </div>
    );
  }

  return (
    <div className="rounded-xl border border-secondary-200 bg-white p-5">
      <h3 className="font-semibold text-secondary-900">{title}</h3>
      <div className="mt-4 space-y-3">
        {items.map((item) => (
          <div key={item.label}>
            <div className="mb-1 flex items-center justify-between text-sm">
              <span className="text-secondary-700">{item.label}</span>
              <span className="font-medium text-secondary-900">{valueFormatter(item.value)}</span>
            </div>
            <div className="h-2 rounded-full bg-secondary-100">
              <div
                className="h-2 rounded-full bg-primary-500 transition-all"
                style={{ width: `${Math.max(6, (item.value / max) * 100)}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
